import { MDBBtn, MDBChip, MDBModalBody, MDBModalFooter, MDBTable, MDBTableBody, MDBTableHead } from 'mdb-react-ui-kit';
import React, { forwardRef, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const AddUserAndExternal = forwardRef((props, ref) => {
  const { t, i18n } = useTranslation();
  const [userExternalList, setUserExternalList] = useState([]);
  const [existingUserNum, setExistingUserNum] = useState([]);
  const [addList, setAddList] = useState([]);
  const [addUniqueList, setAddUniqueList] = useState(new Set());;

  let proccessdRows = [];
  userExternalList && userExternalList.map((list) => {
    proccessdRows.push({
      title: list.title,
      extension_number: (list.extension ? list.extension : list.member),
      member: list.member,
      extnum_user_id: list.extnum_user_id,
    });
  });

  function addItem(handleObj) {
    const itemIdex = addList.findIndex((item) => item.member === handleObj.member);
    if (itemIdex === -1) {
      const updateList = [...addList, handleObj]
      setAddList(updateList)
      const addunique = new Set(updateList.map(item => item.member));
      setAddUniqueList(addunique);
    }
  }

  function handleDelete(fieldObj) {
    const updateAddList = addList.filter((item) => item.member !== fieldObj.member);
    setAddList(updateAddList);
    const addunique = new Set(updateAddList.map(item => item.member));
    setAddUniqueList(addunique);
  }

  const handleAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    let addRecord = [];
    if (addList.length > 0) {
      props.setunSaveUserNumber(addList);
      addList.map(item => {
        addRecord.push(
          {
            user_num_id: "",
            member: item.member,
            title: item.title,
            extension_number: item?.extension_number || item?.extension || item?.member,
            extnum_user_id: item.extnum_user_id,
            isNewMember: true,
          }
        )
      })
      props.onClose();
      props.addExtNum(addRecord);
    }


  }

  useEffect(() => {
    if (props.addUserNumDetails && Object.keys(props.addUserNumDetails).length > 0) {
      const sourceList = props?.addUserNumDetails?.userNumList ?? [];
      const  filteredUserNumList = props?.addUserNumDetails?.userNumList?.filter(
          user =>
            !props?.addUserNumDetails?.existingUserNum?.some(
              existing => existing.member === user.member
            )
        );
      
      setUserExternalList(filteredUserNumList ?? []);
      setExistingUserNum(props?.addUserNumDetails?.existingUserNum ?? []);

      if (props.unSaveUserNumber && props.unSaveUserNumber.length > 0) {
        let updateList = [];
        if (props?.addUserNumDetails?.existingUserNum && props?.addUserNumDetails?.existingUserNum.length > 0) {
          updateList = [...existingUserNum, ...props.unSaveUserNumber];

        } else {

          updateList = [...props.unSaveUserNumber];
        }
        setExistingUserNum(updateList);
        const addUserextension = new Set(updateList.map(item => item.member));
        const newAddUsers = sourceList.filter(item => !addUserextension.has(item.member));
        setUserExternalList(newAddUsers);
      }
    }
  }, [props.addUserNumDetails]);

  const tableData = {
    columns: [
      { label: 'Name', field: 'title', sort: true },
      { label: 'Extension Or Number', field: 'extension_number', sort: false },

    ],
    rows: proccessdRows,
  };

  function setSelectAll(e) {
    e.preventDefault();
    e.stopPropagation();

    const addUserextension = new Set(addList.map(item => item.extension));
    const newAddUsers = userExternalList.filter(item => !addUserextension.has(item.extension));
    const finalAddUsers = addList.concat(newAddUsers);
    setAddList(finalAddUsers);
    const addunique = new Set(finalAddUsers.map(item => item.member));
    setAddUniqueList(addunique);



    // const itemIdex = addList.findIndex((item) => item.member === handleObj.member);
    // if (itemIdex === -1) {
    //   const updateList = [...addList, handleObj]
    //   setAddList(updateList)
    //   const addunique = new Set(updateList.map(item => item.member));
    //   setAddUniqueList(addunique);
    // }
  }
  return (
    <>
      <MDBModalBody>
        <div>
          <div className="form-group row">
            <div className="col-12">
              <div className="form-outlines phoneNumberheight p-0"></div>
              <div className="adduserSequencr">
                <div className="chips chips-placeholder">
                  {existingUserNum && existingUserNum.length > 0 && (
                    existingUserNum
                      .map((item) => (
                        <MDBChip
                          key={item.member} className="m-chip d-inline py-2 px-3">
                          {item.title}
                        </MDBChip>
                      ))
                  )}
                  {addList && addList.length > 0 && (
                    addList
                      .map((item) => (
                        <MDBChip
                          onDelete={() => handleDelete(item)} className="m-chip d-inline py-2 px-3"
                          key={item.member} closeIcon size="sm">
                          {item.title}
                        </MDBChip>
                      ))
                  )}
                </div>
              </div>
            </div>
          </div>
          <p className="text-primary ms-2  cursor-pointer" onClick={(e) => setSelectAll(e)}>SelectAll</p>
          <MDBTable className="mt-3"
            hover
            itemScope
            small
          >
            <MDBTableHead className="table-header-sticky">
              <tr >
                {tableData?.columns &&
                  tableData.columns.map((col) => {
                    return (
                      <th scope='col' key={col.field}>
                        {col.label}
                      </th>
                    );
                  })}
              </tr>
            </MDBTableHead>
            <MDBTableBody>
              {tableData?.rows.length > 0 &&
                tableData.rows
                  // .filter((item) => {
                  //     const lowercasedTitle = item.title.toLowerCase();
                  //     const isTitleMatch = lowercasedTitle.includes(searchSourceQuery.toLowerCase());
                  //     const isCodeMatch = item.code && item.code.toString().includes(searchSourceQuery);
                  //     return isTitleMatch || isCodeMatch;

                  // })
                  .map((row) => (
                    <tr

                      className={addUniqueList && addUniqueList?.has(row.member) ? 'addUsers-select' : ''}
                      onClick={() => addItem(row)}>

                      {tableData?.columns.map((column) => (

                        <td>
                          {row[column.field]}
                        </td>
                      ))}
                    </tr>
                  ))}
              {tableData.rows == undefined || tableData?.rows?.length == 0 &&
                <td colSpan={3} className="text-center">
                  No records found
                </td>
              }
            </MDBTableBody>
          </MDBTable>

        </div >
      </MDBModalBody>
      {/* <MDBModalFooter>
        <MDBBtn color="secondary" onClick={(e) => props.onClose(e)}>
          {t("close")}
        </MDBBtn>
        <MDBBtn onClick={(e) => handleAdd(e)}>{t("add")}</MDBBtn>
      </MDBModalFooter> */}
       <div style={{ display: "none" }}>
						<button ref={ref} onClick={(e) => handleAdd(e)}>
							{t("add")}</button>
					</div>
    </>
  )
});

export default AddUserAndExternal
